<template>
    <div class="faq-page">

        <div v-if="search != 'false'" class="md:text-lg text-gray-700 justify-end w-full px-10 lg:px-24 xl:px-48">
            Showing search results for <i class="text-gray-600"> {{ search }}</i>
            <div> 
                <a href="/faqs" class="text-sm text-blue-400 hover:text-blue-500">clear</a>
            </div>      
        </div>
        
        <div class="justify-center w-full px-10 lg:px-24 xl:px-48">
            <div v-for="faq in faqs">
                <faq-question :faq="faq" :expanded="expanded"></faq-question>
            </div>
        </div>
            
    </div>
</template>

<script>
    import FaqQuestion from '../../components/public/faq/FaqQuestion'
    export default {
        name: 'faqs',
        components: {
            FaqQuestion,
        },
        props: ["faqs", "search", "expanded"],
        methods: {
            checkSearch() {
                if (this.search === "false") {
                    return false;
                }
                else {
                    return true;
                }
            }
        }
    }
</script>

<style>
.faq-page {
    transition: all .6s ease;
}
</style>